import { useState } from 'react';

const FacebookFontGenerators = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');

    // Clear input fields
    const clearFields = () => {
      setText('');
      setResult('');
    };

     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(text);

  
  const bold = {
    'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲',
    'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶', 'j': '𝗷',
    'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼',
    'p': '𝗽', 'q': '𝗾', 'r': '𝗿', 's': '𝘀', 't': '𝘁',
    'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆',
    'z': '𝘇', 'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗',
    'E': '𝗘', 'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜',
    'J': '𝗝', 'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡',
    'O': '𝗢', 'P': '𝗣', 'Q': '𝗤', 'R': '𝗥', 'S': '𝗦',
    'T': '𝗧', 'U': '𝗨', 'V': '𝗩', 'W': '𝗪', 'X': '𝗫',
    'Y': '𝗬', 'Z': '𝗭'
  };

  const italic = {
    'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦',
    'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪', 'j': '𝘫',
    'k': '𝘬', 'l': '𝘭', 'm': '𝘮', 'n': '𝘯', 'o': '𝘰',
    'p': '𝘱', 'q': '𝘲', 'r': '𝘳', 's': '𝘴', 't': '𝘵',
    'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 'y': '𝘺',
    'z': '𝘻', 'A': '𝘈', 'B': '𝘉', 'C': '𝘊', 'D': '𝘋',
    'E': '𝘌', 'F': '𝘍', 'G': '𝘎', 'H': '𝘏', 'I': '𝘐',
    'J': '𝘑', 'K': '𝘒', 'L': '𝘓', 'M': '𝘔', 'N': '𝘕',
    'O': '𝘖', 'P': '𝘗', 'Q': '𝘘', 'R': '𝘙', 'S': '𝘚',
    'T': '𝘛', 'U': '𝘜', 'V': '𝘝', 'W': '𝘞', 'X': '𝘟',
    'Y': '𝘠', 'Z': '𝘡'
  };
  const boldItalic = {
    'a': '𝒂', 'b': '𝒃', 'c': '𝒄', 'd': '𝒅', 'e': '𝒆',
    'f': '𝒇', 'g': '𝒈', 'h': '𝒉', 'i': '𝒊', 'j': '𝒋',
    'k': '𝒌', 'l': '𝒍', 'm': '𝒎', 'n': '𝒏', 'o': '𝒐',
    'p': '𝒑', 'q': '𝒒', 'r': '𝒓', 's': '𝒔', 't': '𝒕',
    'u': '𝒖', 'v': '𝒗', 'w': '𝒘', 'x': '𝒙', 'y': '𝒚',
    'z': '𝒛', 'A': '𝑨', 'B': '𝑩', 'C': '𝑪', 'D': '𝑫',
    'E': '𝑬', 'F': '𝑭', 'G': '𝑮', 'H': '𝑯', 'I': '𝑰',
    'J': '𝑱', 'K': '𝑲', 'L': '𝑳', 'M': '𝑴', 'N': '𝑵',
    'O': '𝑶', 'P': '𝑷', 'Q': '𝑸', 'R': '𝑹', 'S': '𝑺',
    'T': '𝑻', 'U': '𝑼', 'V': '𝑽', 'W': '𝑾', 'X': '𝑿',
    'Y': '𝒀', 'Z': '𝒁'
  };
  
  const subscript = {
    'a': 'ₐ', 'b': 'ᵦ', 'c': 'c', 'd': 'ᵈ', 'e': 'ₑ',
    'f': 'ᶠ', 'g': 'ᵍ', 'h': 'ʰ', 'i': 'ᶦ', 'j': 'ʲ',
    'k': 'ₖ', 'l': 'ˡ', 'm': 'ᵐ', 'n': 'ⁿ', 'o': 'ᵒ',
    'p': 'ᵖ', 'q': 'q', 'r': 'ʳ', 's': 'ˢ', 't': 'ᵗ',
    'u': 'ᵘ', 'v': 'ᵛ', 'w': 'ʷ', 'x': 'ˣ', 'y': 'ʸ',
    'z': 'ᶻ', 'A': 'ᴬ', 'B': 'ᴮ', 'C': 'C', 'D': 'ᴰ',
    'E': 'ᴱ', 'F': 'ᶰ', 'G': 'G', 'H': 'ᴴ', 'I': 'ᴵ',
    'J': 'J', 'K': 'ᴷ', 'L': 'ᴸ', 'M': 'ᴹ', 'N': 'ᴺ',
    'O': 'O', 'P': 'P', 'Q': 'Q', 'R': 'ᴿ', 'S': 'S',
    'T': 'T', 'U': 'ᵁ', 'V': 'V', 'W': 'W', 'X': 'X',
    'Y': 'Y', 'Z': 'Z'
  };

  const bubbletext = {
    'a': 'ⓐ', 'b': 'ⓑ', 'c': 'ⓒ', 'd': 'ⓓ', 'e': 'ⓔ',
    'f': 'ⓕ', 'g': 'ⓖ', 'h': 'ⓗ', 'i': 'ⓘ', 'j': 'ⓙ',
    'k': 'ⓚ', 'l': 'ⓛ', 'm': 'ⓜ', 'n': 'ⓝ', 'o': 'ⓞ',
    'p': 'ⓟ', 'q': 'ⓠ', 'r': 'ⓡ', 's': 'ⓢ', 't': 'ⓣ',
    'u': 'ⓤ', 'v': 'ⓥ', 'w': 'ⓦ', 'x': 'ⓧ', 'y': 'ⓨ',
    'z': 'ⓩ', 'A': 'Ⓐ', 'B': 'Ⓑ', 'C': 'Ⓒ', 'D': 'Ⓓ',
    'E': 'Ⓔ', 'F': 'Ⓕ', 'G': 'Ⓖ', 'H': 'Ⓗ', 'I': 'Ⓘ',
    'J': 'Ⓙ', 'K': 'Ⓚ', 'L': 'Ⓛ', 'M': 'Ⓜ', 'N': 'Ⓝ',
    'O': 'Ⓞ', 'P': 'Ⓟ', 'Q': 'Ⓠ', 'R': 'Ⓡ', 'S': 'Ⓢ',
    'T': 'Ⓣ', 'U': 'Ⓤ', 'V': 'Ⓥ', 'W': 'Ⓦ', 'X': 'Ⓧ',
    'Y': 'Ⓨ', 'Z': 'Ⓩ'
  };

  const bubbleFilled = {
    'a': '🅐', 'b': '🅑', 'c': '🅒', 'd': '🅓', 'e': '🅔',
    'f': '🅕', 'g': '🅖', 'h': '🅗', 'i': '🅘', 'j': '🅙',
    'k': '🅚', 'l': '🅛', 'm': '🅜', 'n': '🅝', 'o': '🅞',
    'p': '🅟', 'q': '🅠', 'r': '🅡', 's': '🅢', 't': '🅣',
    'u': '🅤', 'v': '🅥', 'w': '🅦', 'x': '🅧', 'y': '🅨',
    'z': '🅩', 'A': '🅐', 'B': '🅑', 'C': '🅒', 'D': '🅓',
    'E': '🅔', 'F': '🅕', 'G': '🅖', 'H': '🅗', 'I': '🅘',
    'J': '🅙', 'K': '🅚', 'L': '🅛', 'M': '🅜', 'N': '🅝',
    'O': '🅞', 'P': '🅟', 'Q': '🅠', 'R': '🅡', 'S': '🅢',
    'T': '🅣', 'U': '🅤', 'V': '🅥', 'W': '🅦', 'X': '🅧',
    'Y': '🅨', 'Z': '🅩'
  };
  

  const squared = {
    'a': '🄰', 'b': '🄱', 'c': '🄲', 'd': '🄳', 'e': '🄴',
    'f': '🄵', 'g': '🄶', 'h': '🄷', 'i': '🄸', 'j': '🄹',
    'k': '🄺', 'l': '🄻', 'm': '🄼', 'n': '🄽', 'o': '🄾',
    'p': '🄿', 'q': '🅀', 'r': '🅁', 's': '🅂', 't': '🅃',
    'u': '🅄', 'v': '🅅', 'w': '🅆', 'x': '🅇', 'y': '🅈',
    'z': '🅉', 'A': '🄰', 'B': '🄱', 'C': '🄲', 'D': '🄳',
    'E': '🄴', 'F': '🄵', 'G': '🄶', 'H': '🄷', 'I': '🄸',
    'J': '🄹', 'K': '🄺', 'L': '🄻', 'M': '🄼', 'N': '🄽',
    'O': '🄾', 'P': '🄿', 'Q': '🅀', 'R': '🅁', 'S': '🅂',
    'T': '🅃', 'U': '🅄', 'V': '🅅', 'W': '🅆', 'X': '🅇',
    'Y': '🅈', 'Z': '🅉'
  };
  

  const squareInverted = {
    'a': '🅰', 'b': '🅱', 'c': '🅲', 'd': '🅳', 'e': '🅴',
    'f': '🅵', 'g': '🅶', 'h': '🅷', 'i': '🅸', 'j': '🅹',
    'k': '🅺', 'l': '🅻', 'm': '🅼', 'n': '🅽', 'o': '🅾',
    'p': '🅿', 'q': '🆀', 'r': '🆁', 's': '🆂', 't': '🆃',
    'u': '🆄', 'v': '🆅', 'w': '🆆', 'x': '🆇', 'y': '🆈',
    'z': '🆉', 'A': '🅰', 'B': '🅱', 'C': '🅲', 'D': '🅳',
    'E': '🅴', 'F': '🅵', 'G': '🅶', 'H': '🅷', 'I': '🅸',
    'J': '🅹', 'K': '🅺', 'L': '🅻', 'M': '🅼', 'N': '🅽',
    'O': '🅾', 'P': '🅿', 'Q': '🆀', 'R': '🆁', 'S': '🆂',
    'T': '🆃', 'U': '🆄', 'V': '🆅', 'W': '🆆', 'X': '🆇',
    'Y': '🆈', 'Z': '🆉'
  };
  

  const wideText = {
    'a': 'ａ', 'b': 'ｂ', 'c': 'ｃ', 'd': 'ｄ', 'e': 'ｅ',
    'f': 'ｆ', 'g': 'ｇ', 'h': 'ｈ', 'i': 'ｉ', 'j': 'ｊ',
    'k': 'ｋ', 'l': 'ｌ', 'm': 'ｍ', 'n': 'ｎ', 'o': 'ｏ',
    'p': 'ｐ', 'q': 'ｑ', 'r': 'ｒ', 's': 'ｓ', 't': 'ｔ',
    'u': 'ｕ', 'v': 'ｖ', 'w': 'ｗ', 'x': 'ｘ', 'y': 'ｙ',
    'z': 'ｚ', 'A': 'Ａ', 'B': 'Ｂ', 'C': 'Ｃ', 'D': 'Ｄ',
    'E': 'Ｅ', 'F': 'Ｆ', 'G': 'Ｇ', 'H': 'Ｈ', 'I': 'Ｉ',
    'J': 'Ｊ', 'K': 'Ｋ', 'L': 'Ｌ', 'M': 'Ｍ', 'N': 'Ｎ',
    'O': 'Ｏ', 'P': 'Ｐ', 'Q': 'Ｑ', 'R': 'Ｒ', 'S': 'Ｓ',
    'T': 'Ｔ', 'U': 'Ｕ', 'V': 'Ｖ', 'W': 'Ｗ', 'X': 'Ｘ',
    'Y': 'Ｙ', 'Z': 'Ｚ', '0': '０', '1': '１', '2': '２',
    '3': '３', '4': '４', '5': '５', '6': '６', '7': '７',
    '8': '８', '9': '９', ' ': '　', '.': '．', ',': '，',
    '!': '！', '?': '？', '@': '＠', '#': '＃', '$': '＄',
    '%': '％', '&': '＆', '*': '＊', '(': '（', ')': '）',
    '-': '－', '+': '＋', '=': '＝', '/': '／', ':': '：',
    ';': '；', '<': '＜', '>': '＞', '[': '［', ']': '］',
    '{': '｛', '}': '｝', '|': '｜', '\\': '＼', '\'': '＇',
    '"': '＂', '`': '｀', '~': '～', '^': '＾', '_': '＿'
  };
  

  const heartBeat = (text) => {
    return `💓${text}💓`;
  };

  
  const transformText = (text, styleMap) => {
    return text.split('').map(char => styleMap[char] || char).join('');
  };

  
  const styles = [
    { name: 'Normal', style: (text) => text },
    { name: 'Italic', style: (text) => transformText(text, italic) },
    { name: 'Bold', style: (text) => transformText(text, bold) },
    { name: 'Bold Italic', style: (text) => transformText(text, boldItalic)},
    { name: 'Subscript', style: (text) => transformText(text, subscript) },
    { name: 'Bubble Text', style:  (text) =>transformText(text, bubbletext) },
    { name: 'Bubble Filled', style:  (text) =>transformText(text, bubbleFilled) },
    { name: 'Squared', style:  (text) =>transformText(text, squared) },
    { name: 'Squared Inverted', style:  (text) =>transformText(text, squareInverted) },
    { name: 'Wide Text', style: (text) => transformText(text, wideText) },
    { name: 'Heart Beat', style: heartBeat },
  ];

  
  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  
  const handleStyleChange = (styleFunc) => {
    const transformedText = styleFunc(text);
    setResult(transformedText);
  };


  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label
  
  const handleCopyClick = () => {
    navigator.clipboard.writeText(result);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      
      <textarea
        className="w-full h-32 p-2 mb-4 border border-gray-400 rounded focus:outline-none focus:ring focus:border-blue-500"
        value={text}
        onChange={handleTextChange}
        placeholder="Enter your text here"
      />

      <div className="flex flex-wrap mb-4">
        {styles.map((style, index) => (
          <button
            key={index}
            className="mr-2 mb-2 py-2 px-4 bg-blue-500 hover:bg-blue-700 text-white font-bold rounded focus:outline-none focus:ring focus:border-blue-500"
            onClick={() => handleStyleChange(style.style)}
          >
            {style.name}
          </button>
        ))}
      </div>

      <div className="mb-4">
        <h2 className="text-2xl font-bold mb-2">Result:</h2>
        <div className="p-2 border border-gray-400 rounded break-all">
          {result}
        </div>
      </div>

   <button className="btn btn-primary" onClick={handleCopyClick}>
  {copyButtonLabel}
  </button>

      <button className="btn btn-danger" onClick={clearFields}>
            Clear
          </button>


          <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
    </div>
  );
};

export default FacebookFontGenerators;

